import React from 'react';
import './SidebarSvgImage.css';

// Preserve the original SVG and CSS filter normally. Partner previews paint its
// alpha mask instead, so every image icon can use the exact brand accent.
export default function SidebarSvgImage({src, className = '', loading = 'eager', decoding = 'async'}) {
  return <span className={`${className} sidebar-svg-image`.trim()} aria-hidden="true"
    style={{'--sidebar-svg-source': `url(${JSON.stringify(src)})`}}>
    <img src={src} alt="" loading={loading} decoding={decoding}/>
  </span>;
}
